// @flow
import {getOSMSuggestionsApi} from '../../api';
import {MapAutocompleteServices} from '../MapServices';

import type {SuggestedAddress} from '../MapServices';

type OSMPlaceSuggested = {
  place_id: number,
  licence: string,
  osm_type: string,
  osm_id: number,
  boundingbox: string[],
  lat: string,
  lon: string,
  display_name: string,
  class: string,
  type: string,
  importance: number,
  icon: string,
};

export class OpenStreetMapsAutocompleteServices
  implements MapAutocompleteServices {
  enabledAutoCompleteService: boolean;

  limitResponse: number;

  constructor(provider: any) {
    this.enabledAutoCompleteService = true;
    this.limitResponse = 10;
  }

  getPlaceSuggestions = (input: string, country: ?string): Promise<any> => {
    if (this.enabledAutoCompleteService) {
      return getOSMSuggestionsApi({
        countrycodes: country ? country : '',
        q: input,
        format: 'json',
        limit: this.limitResponse.toString(),
      }).toPromise();
    }
    return new Promise(function(resolve, reject) {
      resolve(null);
    });
  };

  formatPredictions = (
    data: OSMPlaceSuggested[]
  ): {predictions: SuggestedAddress[]} => {
    if (this.enabledAutoCompleteService) {
      const predictions: SuggestedAddress[] = data
        .map((city: OSMPlaceSuggested) => ({
          ...city,
          description: city.display_name,
          placeId: city.osm_id,
        }))
        .filter(loc => loc.class === 'boundary')
        .slice(0, 5);

      return {predictions};
    } else {
      return {predictions: []};
    }
  };

  getPlaceId = (placeId: string): Promise<any> => {
    if (this.enabledAutoCompleteService) {
      console.log('getPlaceId IS NOT IMPLEMENTED');
    }
    return new Promise(function(resolve, reject) {
      resolve(null);
    });
  };

  formatLocation = (location: {[key: string]: string}) => {
    console.log('formatLocation IS NOT IMPLEMENTED');
    return null;
  };
}
